<template>
    <div class="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-950 via-gray-900/95 to-black px-4">
      
      <div class="bg-gray-900 p-8 rounded-2xl shadow-xl w-full max-w-md space-y-6">
        
        <div class="text-center">
          <h1 class="text-2xl font-bold text-white mb-2">Sign Up</h1>
        </div>
  
        <form @submit.prevent="signup" class="space-y-5">
  
          <div>
            <label class="text-gray-300 text-sm mb-1 block" for="name">Name</label>
            <input
              v-model="credentials.name"
              type="text"
              id="name"
              placeholder="Your Name"
              class="w-full px-4 py-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-500"
              required
            />
          </div>
  
          <div>
            <label class="text-gray-300 text-sm mb-1 block" for="email">Email</label>
            <input
              v-model="credentials.email"
              type="email"
              id="email"
              placeholder="admin@example.com"
              class="w-full px-4 py-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-500"
              required
            />
          </div>
  
          <div>
            <label class="text-gray-300 text-sm mb-1 block" for="password">Password</label>
            <input
              v-model="credentials.password"
              type="password"
              id="password"
              placeholder="••••••••"
              class="w-full px-4 py-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-500"
              required
            />
          </div>
  
          <div>
            <label class="text-gray-300 text-sm mb-1 block" for="confirmPassword">Confirm Password</label>
            <input
              v-model="credentials.confirm"
              type="password"
              id="confirmPassword"
              placeholder="••••••••"
              class="w-full px-4 py-3 rounded-xl bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-500"
              required
            />
          </div>
  
          <primary-button type="submit" class="w-full justify-center">
            Sign Up
          </primary-button>
  
        </form>
  
        <p v-if="error" class="text-red-500 text-sm text-center">{{ error }}</p>
  
      </div>
  
    </div>
</template>
  
<script setup>
  import PrimaryButton from '@/components/button/PrimaryButton.vue'
  import { ref } from 'vue'
  import api from '@/utils/api'
  import { storeUserCredentials } from '@/utils/userCredentials'
  import { useRouter } from 'vue-router'
  
  const error = ref('')
  const router = useRouter()
  const credentials = ref({
    name: '',
    email: '',
    password: '',
    confirm: ''
  })

  // validate the credentials before submission
  const credentialsValidation = () => {
    error.value = ''
  
    if (!credentials.value.name || !credentials.value.email || !credentials.value.password || !credentials.value.confirm) {
      error.value = 'Please fill in all fields.'
      return false
    }

    if (!credentials.value.email.includes('@')) {
      error.value = 'Please enter a valid email address.'
      return false
    }

    if (credentials.value.password.length < 6) {
      error.value = 'Password must be at least 6 characters long.'
      return false
    }

    if (credentials.value.password !== credentials.value.confirm) {
      error.value = 'Passwords do not match.'
      return false
    }
  }

  const signupRequest = async () => {
    try {
      const response = await api.post('/signup', credentials.value)

      if (response.data.status == 'error')
      {
        error.value = 'Some unknown error occured!'
      }

      if (response.data.status == 'success')
      {
        storeUserCredentials(response.data.user, response.data.token)
        router.push({
          path: '/'
        })
      }
    } catch (error)
    {
      console.error(error)
    }
  }
  
  const signup = () => {
    
    if (credentialsValidation() == false)
    {
      return 
    }
    signupRequest()
    // Dummy signup simulation (replace with API call)
    console.log('Signup successful', { name: credentials.value.name, email: credentials.value.email })
  
    // After successful signup:
    // router.push('/admin')
  }
  </script>
  